// src/components/NewArrival/NewArrival.js

import React, { useEffect, useState } from "react";
import "./NewArrival.css";
import Icons from "../../../../Config/Images";
import { useLocation, useNavigate } from "react-router-dom";
import ProductCard from "../../CustomComponents/ProductCard"; // Import your custom ProductCard
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUserDetailsAPI } from "../../../../Store/Action/UserAction";

const NewArrival = ({ data, onFetchGetWishlist,userRole }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [newArrivals, setNewArrivals] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Loading state
  // const [userRole, setUserRole] = useState("");
  const isWastageEnabled = useSelector(
    (state) => state.wastage.isWastageEnabled
  );
  // const [isWastageEnabled, setIsWastageEnabled] = useState(true);
  // useEffect(() => {
  //   dispatch(
  //     getLoggedInUserDetailsAPI({}, (result) => {
  //       // setUserRole(result?.data?.[0]?.user_role_name);
  //       const booleanValue =
  //         result?.data?.[0]?.user_generic_data_value?.[0]
  //           ?.user_generic_data_boolean_value;

  //       if (typeof booleanValue === "boolean") {
  //         setIsWastageEnabled(booleanValue);
  //       } else if (booleanValue === 0 || booleanValue === 1) {
  //         setIsWastageEnabled(booleanValue === 1);
  //       }
  //     })
  //   );
  // }, [dispatch]);

  useEffect(() => {
    if (data) {
      setNewArrivals(data);
    }
  }, [data]);

  const handleViewAllClick = () => {
    navigate("/new-arrival-products", { state: "fromNewArrival" });
  };

  const handleProductClick = (productId) => {
    navigate(`/productDetail/${productId}`, { state: { productId } });
  };

  // useEffect(() => {
  //   dispatch(
  //     getLoggedInUserDetailsAPI({}, (result) => {
  //       setUserRole(result?.data?.[0]?.user_role_name);
  //     })
  //   );
  // }, [dispatch]);
  return (
    <div className="topSellingProductsDiv newArrivalMainDiv">
      <div className="upperContent">
        <h1>New Arrival</h1>
        <p>Explore fresh, unique designs now available on Zabali</p>
      </div>

      <div className="lowerContent">
        <div className="hrLine" />
        <div className="view-all">
          <p onClick={handleViewAllClick} style={{ display: "inline-block" }}>
            View all
          </p>
        </div>
        <div className="cardsMainDiv">
          {isLoading ? (
            <p>Loading...</p>
          ) : newArrivals.length > 0 ? (
            newArrivals?.map((prod, index) => (
              <ProductCard
                key={index}
                image={
                  prod?.product_image?.product_image_url || Icons.default_image
                }
                // title={
                //   prod?.product_subCategory_name
                //     ? `${prod?.product_subCategory_name} (${prod?.stamp_purity_value}, ${prod?.stamp_melting_purity_value})`
                //     : `${prod?.product_name}`
                // }
                title={prod.product_name}
                // netWeight={prod?.product_net_weight || "N/A"}
                wastage={prod?.product_wastage}
                // fine={
                //   userRole?.toLowerCase() === "retailer"
                //     ? prod?.product_retailer_per_pcs_fine
                //     : userRole?.toLowerCase() === "wholesaler"
                //     ? prod?.product_whole_seller_per_pcs_fine
                //     : "N/A"
                // }
                product={prod}
                isWishlist={prod?.wishlist_id}
                onGetWishlistProduct={onFetchGetWishlist}
                flagCart={prod?.flag_cart}
                userRole={userRole}
                isWastageEnabled={isWastageEnabled}
              />
            ))
          ) : (
            <p>No new arrivals available</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewArrival;
